<meter #meter high="0.25" max="1" value="0"></meter>